import React from "react";

function SyncIcon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      fill="none"
      viewBox="0 0 16 15"
      {...props}
    >
      <path
        stroke={props.stroke || '#052f35 '}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.15"
        d="M14.474 4.927L12.407 2.86c-.78-.78-1.852-.741-2.379.098l-1.15 1.82 3.685 3.686 1.82-1.15c.787-.501.833-1.652.091-2.387z"
      ></path>
      <path
        stroke={props.stroke || '#052f35 '}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.15"
        d="M12.563 8.457l.156 2.678c.15 1.495-.37 2.015-1.787 2.184l-5.669.67c-1.196.137-2.054-.722-1.911-1.911L4 8M8.877 4.777L8 4.78M4.132 13.21l2.067-2.073"
      ></path>
      <path
        stroke={props.stroke || '#052f35 '}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.15"
        d="M8 4.5c0 .319-.047.638-.132.933A3.465 3.465 0 016.802 7.13 3.448 3.448 0 014.5 8c-.397 0-.77-.062-1.12-.187a3.474 3.474 0 01-1.874-1.509A3.5 3.5 0 011 4.5a3.46 3.46 0 011.314-2.73A3.495 3.495 0 018 4.5z"
      ></path>
      <path
        stroke="#158BF8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.55"
        d="M3.216 5.319c.058.096.128.187.209.267a1.523 1.523 0 002.15 0c.242-.241.38-.547.425-.86M3 4.296c.045-.316.183-.618.425-.86a1.523 1.523 0 012.15 0c.084.084.151.174.21.268"
      ></path>
      <path
        stroke="#158BF8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.55"
        d="M3.155 6.176v-.86h.859M5.846 2.844v.86h-.86"
      ></path>
    </svg>
  );
}

export default SyncIcon;
